var popularCountries = vueIfExists({
  el: '#popular-countries',
  mixins: [win.map,win.toggleCollapse],
  data: {
     pageWidth: Math.max(html.clientWidth, win.innerWidth || 0)
  },
  methods: {
  	destinationMapSrc: function(type) {
  		var size;
		size = {w: 290, h: 230};
		if (type == 'home') {
			if (this.pageWidth > 320 && this.pageWidth <= 375) {
				size = {w: 345, h: 230};
			} else if (this.pageWidth > 375 && this.pageWidth < 768) {
				size = {w: 720, h: 230};
			} else if (this.pageWdith >= 768 && this.pageWidth < 1221) {
				size= {w: 487, h: 226};
			} else if (this.pageWidth >= 1221) {
				size = {w: 575, h: 210}; 
			}
		} else {
			if (this.pageWidth > 320 && this.pageWidth <= 375) {
				size = {w: 345, h: 230};
			} else if (this.pageWidth > 375 && this.pageWidth < 768) {
				size = {w: 720, h: 230};
			} else if (this.pageWdith >= 768 && this.pageWidth < 1045) {
				size = {w: 404, h: 260};
			} else if (this.pageWidth >= 1045) {
				size = {w: 278, h: 260}; 
			}
		}

	  	return this.mapThumbSrc(size.w, size.h, type);
  	}
  }
});
